// extracted by mini-css-extract-plugin
export var columnTextOne = "featuresItem-module--columnTextOne--171df";
export var dark = "featuresItem-module--dark--9c0c2";
export var feature = "featuresItem-module--feature--8d896";
export var light = "featuresItem-module--light--95c66";
export var styledBodyContent = "featuresItem-module--styledBodyContent--513ea";
export var styledBorder = "featuresItem-module--styledBorder--3db7c";
export var styledButtons = "featuresItem-module--styledButtons--a839d";
export var styledHeaderContent = "featuresItem-module--styledHeaderContent--d5b82";
export var styledHeaderLeftContent = "featuresItem-module--styledHeaderLeftContent--f3ebe";